import React, { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

const CHANNEL_NAME = 'hubspot_oauth'

const HubSpotCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const hubspot = searchParams.get('hubspot')
    const reason = searchParams.get('reason') ?? undefined
    const result = hubspot === 'connected' ? 'connected' : 'error'

    // BroadcastChannel is the reliable path — works even when window.opener is
    // nulled out by the browser after cross-origin redirect chains.
    try {
      const channel = new BroadcastChannel(CHANNEL_NAME)
      channel.postMessage({ type: 'hubspot_oauth', result, reason })
      channel.close()
    } catch {
      // BroadcastChannel not supported — fall back to postMessage
    }

    try {
      if (window.opener) {
        window.opener.postMessage(
          { type: 'hubspot_oauth', result, reason },
          window.location.origin,
        )
      }
    } catch {
      // opener may be restricted
    }

    try {
      window.close()
    } catch {
      // some browsers block window.close() — fall through to navigate
    }

    const t = setTimeout(() => {
      if (!window.closed) {
        navigate('/dashboard/settings', { replace: true })
      }
    }, 300)

    return () => clearTimeout(t)
  }, [searchParams, navigate])

  return (
    <div className="flex h-screen items-center justify-center">
      <p className="text-sm text-gray-500">Completing HubSpot connection…</p>
    </div>
  )
}

export default HubSpotCallbackPage
